module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-14.5c70f69f.mp3";